import { render, staticRenderFns } from "./TheOracleModuleRoleAddForm.vue?vue&type=template&id=d9053faa&"
import script from "./TheOracleModuleRoleAddForm.vue?vue&type=script&lang=js&"
export * from "./TheOracleModuleRoleAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports